import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class RetriveImportacaoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'retrive-importacao');
  }

  // Listar com filtros
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.usuario_id) {
      params = params.set('usuario_id', filtros.usuario_id);
    }
    if (filtros.status !== undefined) {
      params = params.set('status', filtros.status);
    }
    if (filtros.data_inicial) {
      params = params.set('data_inicial', filtros.data_inicial);
    }
    if (filtros.data_final) {
      params = params.set('data_final', filtros.data_final);
    }
    if (filtros.order_by) {
      params = params.set('order_by', filtros.order_by);
    }
    if (filtros.order_dir) {
      params = params.set('order_dir', filtros.order_dir);
    }
    if (filtros.per_page) {
      params = params.set('per_page', filtros.per_page);
    }
    if (filtros.page) {
      params = params.set('page', filtros.page);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  // Criar importação com retrives
  criarComRetrives(dados: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/with-retrives`, dados);
  }

  // Obter dados comparativos (retrive vs dados_variavel)
  obterDadosComparativos(retriveImportacaoId: number): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/${retriveImportacaoId}/comparativo`);
  }

}

